export { default as isEqual } from './is-equal';
export { default as isLight } from './is-light';
export { default as isDark } from './is-dark';
